/**
 * @file AddBtn
 */

'use strict';
import Common from '../../Utils/Common';

/**
 * @classname WarningContinuationModal
 * @classdesc WarningContinuationModal
 */
export default class WarningContinuationModal {
	/**
	 * @constructor
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 */
	constructor($e) {
		console.log(`WarningContinuationModal.constructor`);
		console.log(document.getElementById('continuation_warning_type').value);
		const continuationType = document.getElementById('continuation_warning_type').value === 'transfer' ? '移籍' : '従登録';

		if ($e.val() === '1') Common.showWarningModal(`<p class="text text-danger fwb">${continuationType}する年度を確認したうえで進めてください。`);
	};
}
